import { useEffect, useState, Fragment } from 'react'
import { Globe, ChevronDown, ChevronUp } from 'lucide-react'
import type { IMessage } from '@/types/chat'
interface ICurrent {
  event: string
  data: any
}

const ToolContent = ({ content }: { content: IMessage }) => {
  const [showContent, setShowContent] = useState(false)
  const [current, setcurrent] = useState<ICurrent | null>(null)
  const [response, setResponse] = useState<any>({})
  const [curOpenIndex, setCurOpenIndex] = useState<number>(0)

  const { events, text, stop } = content

  useEffect(() => {
    if (events?.length) {
      const current = events[events.length - 1]
      setcurrent(current)
      if (current?.event === 'toolResponse') {
        const response = JSON.parse(current?.data.tool?.response || {})
        setResponse(response)
        curOpenIndex + 1 !== response.news.length &&
          setTimeout(() => {
            setCurOpenIndex(curOpenIndex + 1)
          }, 400)
      }
    }
  }, [curOpenIndex, events])

  const handleContent = () => {
    setShowContent(!showContent)
  }

  const openWebsite = (url: any) => {
    window.open(url)
  }

  if (!events?.length) return null

  // 临时方案，只处理搜索工具渲染
  if (current?.data?.tool?.toolName !== '百度搜索') {
    return null
  }

  return (
    <div className="text-sm font-medium">
      <div
        className="inline-flex items-center gap-1 cursor-pointer line-clamp-1"
        onClick={handleContent}
      >
        {(text && current?.event === 'toolResponse') || stop === 1 ? (
          <Globe size={16} />
        ) : (
          <img
            className="w-5 h-5"
            src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
          />
        )}

        <div className="flex items-center flex-1 gap-1">
          {current?.event === 'toolCall' && <span> 联网搜索中...</span>}
          {!text && current?.event === 'toolResponse' && stop !== 1 && (
            <span
              key={curOpenIndex} // 添加 key 属性，使其在 curOpenIndex 变化时重新渲染
              className="line-clamp-1 flex-1 transition-opacity duration-300 ease-in-out" // 添加过渡效果类
            >
              打开网页：{response?.news?.[curOpenIndex]?.title}
            </span>
          )}
          {((text && current?.event === 'toolResponse') || stop === 1) && (
            <span className="line-clamp-1 flex-1">
              搜索完成，共找到
              {response?.news?.length || 0}
              个网页并参考内容
            </span>
          )}
          {showContent ? (
            <ChevronUp strokeWidth={2} size={16} />
          ) : (
            <ChevronDown strokeWidth={2} size={16} />
          )}
        </div>
      </div>
      {showContent && (
        <div className="flex flex-col gap-4 px-5 pt-4">
          {events?.map((item: any, index: number) => {
            if (item.event === 'toolCall') {
              return (
                <Fragment key={index}>
                  <div className="flex items-center gap-1">
                    <div className="line-clamp-1">
                      联网搜索：
                      {item.data?.tool.params &&
                        JSON.parse(item.data?.tool.params)?.keywords}
                    </div>
                  </div>
                </Fragment>
              )
            }
            if (item.event === 'toolResponse') {
              return (
                <Fragment key={index}>
                  <div className="flex flex-col gap-2">
                    <div>打开网页：</div>
                    {response?.news?.map((item: any, index: any) => (
                      <div
                        key={index}
                        className="cursor-pointer text-content-link font-normal"
                        onClick={() => {
                          openWebsite(item.url)
                        }}
                      >
                        <div
                          className="flex items-center"
                          onClick={() => {
                            openWebsite(item.url)
                          }}
                        >
                          {item.logo && (
                            <img src={item.logo} className="w-4 h-4 mr-1" />
                          )}
                          {/* <img src="https://h5tq.moji.com/f5/assets/tianqi/favicon.ico" className="w-4 h-4 mr-1" /> */}
                          <div className="flex-1 truncate text-sm">
                            {index + 1}. {item.title}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Fragment>
              )
            }
          })}
        </div>
      )}
    </div>
  )
}

export default ToolContent
